import { Typography } from '@navi/web-ui/lib/primitives';
import { InfoIcon, ClockIcon } from '@navi/web-ui/lib/icons';
import { Countdown } from '@cp/src/components/Countdown/Countdown';
import {
  Tooltip as TooltipV2,
  TooltipContent,
  TooltipTrigger,
  Directions
} from '@cp/src/components/TooltipV2/TooltipV2';
import styles from './index.module.scss';

interface CountdownBannerProps {
  message: string | null;
  secondsRemaining: number;
}

const CountdownBanner = ({ message, secondsRemaining }: CountdownBannerProps) => {
  return (
    <div className={styles.countdownBanner}>
      <div className={styles.bannerContent}>
        <Typography variant="h5" color="white">
          Time left to initiate mock
        </Typography>

        <TooltipV2 placement={Directions.TOP} hideStrategy="referenceHidden">
          <TooltipTrigger tooltipTriggerClassName="tooltipTriggerWrapper">
            <InfoIcon width={20} height={20} color="white" />
          </TooltipTrigger>
          <TooltipContent className="tooltipWrapper max-w-[240px] py-2">{message}</TooltipContent>
        </TooltipV2>
      </div>
      <ClockIcon width={20} height={20} color="white" />
      <div className={styles.countdownTimer}>
        <Typography variant="h3" color="white">
          <Countdown
            key={secondsRemaining}
            startFrom={secondsRemaining}
            stopAt={0}
            interval={1000}
            decrementBy={1}
            formatter="HH:MM:SS"
          />
        </Typography>
      </div>
    </div>
  );
};

export default CountdownBanner;
